<template>
  <div class="t-datepicker-filter-fields">
    <Input left-icon="Calendar" readonly :value="startDateFormatted" />
    <div class="t-datepicker-filter-icon">
      <Icon name="ArrowRight" size="18" />
    </div>
    <Input left-icon="Calendar" readonly :value="endDateFormatted" />
  </div>
</template>

<script>
import Input from '../Input/Input.vue';
import Icon from '../Icon/Icon.vue';
import { formatByUnixSeconds } from './convert';

export default {
  components: {
    Input,
    Icon,
  },
  props: {
    startDate: { type: [Date, Number] },
    endDate: { type: [Date, Number] },
    locale: {
      type: String,
      default: 'pt-BR',
      validator: (value) => ['en-US', 'es-ES', 'pt-BR', 'en_US', 'es_ES', 'pt_BR'].includes(value),
    },
  },
  computed: {
    startDateFormatted() {
      return this.getDateFormatted(this.startDate);
    },
    endDateFormatted() {
      return this.getDateFormatted(this.endDate);
    },
    localeFixed() {
      return this.locale.replace('_', '-');
    },
  },
  methods: {
    getDateFormatted(date) {
      return date ? formatByUnixSeconds(date, this.localeFixed) : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.t-datepicker-filter-fields {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  > .t-input {
    width: 242px;
  }
}

.t-datepicker-filter-icon {
  > svg {
    --color: var(--track-color-bluegray-70);
  }
}
</style>
